import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { ArrowLeft } from 'lucide-react';

export default function LegalNotice() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[hsl(35,25%,91%)]">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <Link to="/" className="flex items-center gap-2 text-[hsl(20,10%,40%)] hover:text-[hsl(20,10%,25%)] mb-8">
          <ArrowLeft className="w-4 h-4" />Volver
        </Link>

        <div className="bg-white rounded-2xl shadow-sm border border-[hsl(35,20%,88%)] p-8 sm:p-12">
          <h1 className="font-heading font-bold text-3xl text-gray-900 mb-2">Aviso Legal</h1>
          <p className="text-sm text-gray-500 mb-8">Última actualización: mayo de 2026</p>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">1. Datos identificativos de los titulares</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de los datos identificativos de los cotitulares de este sitio web:
            </p>
            <div className="p-5 bg-[hsl(35,25%,95%)] rounded-xl text-gray-600 space-y-3">
              <div>
                <p><strong>Cotitular:</strong> Alba Pérez Rodríguez</p>
                <p><strong>NIF:</strong> 72596176B</p>
              </div>
              <div>
                <p><strong>Cotitular:</strong> Manuel Arroyo González</p>
                <p><strong>NIF:</strong> 76269479F</p>
              </div>
              <div className="pt-1">
                <p><strong>Denominación comercial:</strong> Partykatu</p>
                <p><strong>Sitio web:</strong> <a href="https://partykatu.com" className="text-[hsl(144,18%,45%)] hover:underline">partykatu.com</a></p>
                <p><strong>Correo electrónico:</strong> <a href="mailto:infopartykatu@gmail.com" className="text-[hsl(144,18%,45%)] hover:underline">infopartykatu@gmail.com</a></p>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">2. Objeto</h2>
            <p className="text-gray-600 leading-relaxed">
              El presente Aviso Legal regula el acceso y uso del sitio web <strong>partykatu.com</strong> y de la aplicación Partykatu. El acceso a este sitio web implica la aceptación plena de las condiciones aquí establecidas. Los titulares se reservan el derecho a modificar este Aviso Legal en cualquier momento, siendo responsabilidad del usuario su revisión periódica.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">3. Propiedad intelectual e industrial</h2>
            <p className="text-gray-600 leading-relaxed">
              Todos los contenidos del sitio web y de la aplicación Partykatu — incluyendo, sin carácter limitativo, textos, fotografías, gráficos, imágenes, iconos, tecnología, software, código fuente, logotipos, marcas, nombres comerciales y diseño gráfico — son propiedad de Alba Pérez Rodríguez y Manuel Arroyo González, o de sus licenciantes, y están protegidos por la legislación española e internacional sobre propiedad intelectual e industrial.
            </p>
            <p className="text-gray-600 leading-relaxed mt-3">
              Queda expresamente prohibida la reproducción, distribución, comunicación pública, transformación o cualquier otro acto de explotación de los contenidos sin la autorización expresa y por escrito de los titulares. El incumplimiento de esta prohibición constituye una infracción de los derechos de propiedad intelectual e industrial y podrá dar lugar a las acciones legales correspondientes.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">4. Responsabilidad</h2>
            <p className="text-gray-600 leading-relaxed">
              Los titulares no se responsabilizan de los daños y perjuicios de cualquier naturaleza que pudieran derivarse del acceso o uso del sitio web, incluyendo los causados por virus informáticos, interrupciones del servicio o problemas técnicos ajenos a su voluntad.
            </p>
            <p className="text-gray-600 leading-relaxed mt-3">
              Los titulares tampoco se responsabilizan de los contenidos de sitios web de terceros accesibles mediante enlaces desde esta plataforma. La existencia de un enlace no implica ninguna relación ni recomendación por parte de Partykatu hacia el sitio enlazado.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">5. Protección de datos</h2>
            <p className="text-gray-600 leading-relaxed">
              El tratamiento de los datos personales de los usuarios se rige por nuestra{' '}
              <Link to="/privacidad" className="text-[hsl(144,18%,45%)] hover:underline">Política de Privacidad</Link>,
              de conformidad con el Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 (LOPDGDD).
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">6. Cookies</h2>
            <p className="text-gray-600 leading-relaxed">
              Partykatu utiliza únicamente cookies técnicas estrictamente necesarias para el funcionamiento del servicio. No se utilizan cookies de seguimiento ni publicidad. Para más información, consulta nuestra{' '}
              <Link to="/privacidad" className="text-[hsl(144,18%,45%)] hover:underline">Política de Privacidad</Link>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">7. Ley aplicable y jurisdicción</h2>
            <p className="text-gray-600 leading-relaxed">
              Este Aviso Legal se rige por la legislación española. Para la resolución de cualquier controversia derivada del acceso o uso de este sitio web, las partes se someten a los Juzgados y Tribunales españoles competentes, sin perjuicio de los derechos que asisten a los consumidores conforme a la normativa europea.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-gray-900 mb-4">8. Contacto</h2>
            <p className="text-gray-600 leading-relaxed">
              Para cualquier consulta relacionada con este Aviso Legal:
            </p>
            <div className="mt-3 p-4 bg-[hsl(35,25%,95%)] rounded-xl text-gray-600">
              <p><strong>Email:</strong> <a href="mailto:infopartykatu@gmail.com" className="text-[hsl(144,18%,45%)] hover:underline">infopartykatu@gmail.com</a></p>
              <p className="mt-1"><strong>Web:</strong> <a href="https://partykatu.com" className="text-[hsl(144,18%,45%)] hover:underline">partykatu.com</a></p>
            </div>
          </section>

          <div className="mt-10 pt-6 border-t border-[hsl(35,20%,88%)] flex flex-wrap gap-4 text-sm">
            <Link to="/privacidad" className="text-[hsl(144,18%,45%)] hover:underline">Política de Privacidad</Link>
            <Link to="/terminos" className="text-[hsl(144,18%,45%)] hover:underline">Términos y Condiciones</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
